// extracted by mini-css-extract-plugin
export default {"SaveBtn":"SaveBtn_SaveBtn__8DCmJ"};